var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
import { CLIENT_STAGES } from './assignment_stage';
export const ASSIGNMENT_STATUS = {
    CLO_AWA: {
        id: 'CLO_AWA',
        title: 'New Request',
        title_extended: 'New Request',
        color: 'blue',
        stage: ((_a = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.new) === null || _a === void 0 ? void 0 : _a.title) || ''
    },
    WRO_AWA: {
        id: 'WRO_AWA',
        title: 'Unallotted',
        title_extended: 'Unallotted',
        color: 'blue',
        stage: ((_b = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _b === void 0 ? void 0 : _b.title) || ''
    },
    WRO_RJT: {
        id: 'WRO_RJT',
        title: 'Unallotted',
        title_extended: 'Unallotted (Writer Passed)',
        color: 'blue',
        stage: ((_c = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _c === void 0 ? void 0 : _c.title) || ''
    },
    WRI_AWA: {
        id: 'WRI_AWA',
        title: 'AWA',
        title_extended: 'AWA',
        color: 'gold',
        stage: ((_d = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _d === void 0 ? void 0 : _d.title) || ''
    },
    WRI_WRK: {
        id: 'WRI_WRK',
        title: 'Writing',
        title_extended: 'Writing',
        color: 'gold',
        stage: ((_e = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _e === void 0 ? void 0 : _e.title) || ''
    },
    EDO_AWA: {
        id: 'EDO_AWA',
        title: 'Written',
        title_extended: 'Written / Translated / Designed',
        color: 'orange',
        stage: ((_f = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _f === void 0 ? void 0 : _f.title) || ''
    },
    EDO_RJT: {
        id: 'EDO_RJT',
        title: 'Written',
        title_extended: 'Written / Translated (Editor Passed)',
        color: 'orange',
        stage: ((_g = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _g === void 0 ? void 0 : _g.title) || ''
    },
    EDI_AWA: {
        id: 'EDI_AWA',
        title: 'AEA',
        title_extended: 'AEA',
        color: 'cyan',
        stage: ((_h = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _h === void 0 ? void 0 : _h.title) || ''
    },
    EDI_WRK: {
        id: 'EDI_WRK',
        title: 'Editing',
        title_extended: 'Editing',
        color: 'cyan',
        stage: ((_j = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _j === void 0 ? void 0 : _j.title) || ''
    },
    EDO_FIN: {
        id: 'EDO_FIN',
        title: 'Edited',
        title_extended: 'Edited (by Creator)',
        color: 'geekblue',
        stage: ((_k = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _k === void 0 ? void 0 : _k.title) || ''
    },
    CLO_FIN: {
        id: 'CLO_FIN',
        title: 'Edited',
        title_extended: 'Edited',
        color: 'geekblue',
        stage: ((_l = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _l === void 0 ? void 0 : _l.title) || ''
    },
    CLI_AWA: {
        id: 'CLI_AWA',
        title: 'Submitted',
        title_extended: 'Submitted',
        color: 'purple',
        stage: ((_m = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.finished) === null || _m === void 0 ? void 0 : _m.title) || ''
    },
    CLI_FIN: {
        id: 'CLI_FIN',
        title: 'Approved',
        title_extended: 'Approved',
        color: 'green',
        stage: ((_o = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.approved) === null || _o === void 0 ? void 0 : _o.title) || ''
    },
    EDI_RWK: {
        id: 'EDI_RWK',
        title: 'Rework',
        title_extended: 'Rework (Editor Rework)',
        color: 'magenta',
        stage: ((_p = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _p === void 0 ? void 0 : _p.title) || ''
    },
    EDO_RWK: {
        id: 'EDO_RWK',
        title: 'Rework',
        title_extended: 'Rework (Editor Ops Rework)',
        color: 'magenta',
        stage: ((_q = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _q === void 0 ? void 0 : _q.title) || ''
    },
    CLO_RWK: {
        id: 'CLO_RWK',
        title: 'Rework',
        title_extended: 'Rework (Client Ops Rework)',
        color: 'magenta',
        stage: ((_r = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _r === void 0 ? void 0 : _r.title) || ''
    },
    CLI_RWK: {
        id: 'CLI_RWK',
        title: 'Rework',
        title_extended: 'Rework (Client Rework)',
        color: 'magenta',
        stage: ((_s = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.rejected) === null || _s === void 0 ? void 0 : _s.title) || ''
    },
    CLI_RJT: {
        id: 'CLI_RJT',
        title: 'Rejected by Client',
        title_extended: 'Rejected by Client',
        color: 'red',
        stage: ((_t = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.rejected) === null || _t === void 0 ? void 0 : _t.title) || ''
    },
    WRI_RJT: {
        id: 'WRI_RJT',
        title: 'Writer Rejected',
        title_extended: 'Writer Rejected',
        color: 'red',
        stage: ((_u = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _u === void 0 ? void 0 : _u.title) || ''
    },
    EDI_RJT: {
        id: 'EDI_RJT',
        title: 'Editor Rejected',
        title_extended: 'Editor Rejected',
        color: 'red',
        stage: ((_v = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.in_progress) === null || _v === void 0 ? void 0 : _v.title) || ''
    },
    HOLD: {
        id: 'HOLD',
        title: 'On Hold',
        title_extended: 'On Hold',
        color: 'magenta',
        stage: ((_w = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.hold) === null || _w === void 0 ? void 0 : _w.title) || ''
    },
    SCRAPPED: {
        id: 'SCRAPPED',
        title: 'Scrapped',
        title_extended: 'Scrapped',
        color: 'magenta',
        stage: ((_x = CLIENT_STAGES === null || CLIENT_STAGES === void 0 ? void 0 : CLIENT_STAGES.scrapped) === null || _x === void 0 ? void 0 : _x.title) || ''
    }
};
//# sourceMappingURL=assignment_status.js.map